import { combineReducers } from '@reduxjs/toolkit';
import EmbeddedSessionExpiredModal from '@/features/customer-facing-dashboards/components/EmbeddedSessionExpiredModal';
import whereModal from './modal_where';
import fromModal from './modal_from';
import groupByModal from './modal_group_by';
import joinModal from './modal_join';
import orderByModal from './modal_order_by';
import columnsModal from './modal_columns';
import saveLayersModal from './modal_save_layers';
import shareViewModal from './modal_share_view';
import exportToSheetsModal from './modal_export_to_sheets';
import selectModal from './modal_select';
import addColumnModal from './modal_add_column';
import sqlEditorModal from './modal_sql_editor';
import csvUploadModal from './modal_csv_upload';
import hiddenColumnsModal from './modal_hidden_columns';
import collaboratorsModal from './modal_collaborators';
import rearrangeColumnsModal from './modal_rearrange_columns';
import renameColumnsModal from './modal_rename_columns';
import aggregateModal from './modal_aggregate';
import shareAsHtmlModal from './modal_share_as_html';
import addDashboardModal from './modal_add_dashboard';
import addAlertModal from './modal_add_alert';
import {
  EXCEPTION,
  FAILED,
  LOADING,
  MODAL_DATA_LOADED,
  MODAL_HIDDEN,
  MODAL_SAVE_CLICKED,
  SAVE_LAYERS_CLICKED,
  USER_NOT_LOGGED_IN,
  DEPENDANT_QUERIES_CLICKED,
  CUSTOMIZE_AGGREGATE_CLICKED,
  EMBEDDED_USER_NOT_LOGGED_IN,
} from '../actions/constants';
import { MODAL_ID } from '../components/modals/PopupModal';
import Column from '../util/Column';
import ModalSaveLayers from '../components/modals/ModalSaveLayers';
import ModalSqlEditor from '../components/modals/ModalSqlEditor';
import ModalCsvUpload from '../components/modals/ModalCsvUpload';
import UserNotLoggedInModal from '../components/modals/UserNotLoggedInModal';
import ModalInvalidLayer from '../components/modals/ModalInvalidLayer';
import ModalDataFailedToLoad from '../components/modals/ModalDataFailedToLoad';
import ModalColumnsContainer from '../containers/ModalColumnsContainer';
import ModalAggregate from '../components/modals/ModalAggregate';
import ModalFrom from '../components/modals/ModalFrom';
import ModalLoading from '../components/modals/ModalLoading';
import DependantQueriesModal from '../components/modals/DependantQueriesModal';
import ModalCustomizeAggregate from '../features/countIf/ModalCustomizeAggregate';
import modalCustomizeAggregateReducer from '../features/countIf/ModalCustomizeAggregate/modalReducer';

const INITIAL_STATE = {
  current: null, // the modal to show (or null if inactive or loading)
  columns: null, // array of Column objs
  existingLayer: null, // the Layer currently being edited, or null if its a new layer being created
  relevantLayers: null, // the layers above the existing layer
  fullScreen: false, // if true, the modal content will fill the full screen
  templateToReplace: null, // the TemplateLayer that was clicked to open this modal (and hence is the step that should be replaced when Done is clicked)
};

function showModal() {
  $(`#${MODAL_ID}`).modal('show');
}

function hideModal() {
  $(`#${MODAL_ID}`).modal('hide');
}

function isFullScreen(modal) {
  return modal === ModalColumnsContainer || modal === ModalAggregate;
}

const meta = (state = INITIAL_STATE, action) => {
  // show modal
  switch (action.type) {
    case LOADING:
      if (action.awaiting === MODAL_DATA_LOADED) {
        const fullScreen = isFullScreen(action.meta.modal);
        if (!fullScreen) {
          showModal();
        }
        return { ...state, current: ModalLoading, fullScreen };
      }
      return state;
    case FAILED:
      if (action.awaiting === MODAL_DATA_LOADED) {
        return { ...state, current: ModalDataFailedToLoad };
      }
      return state;
    case MODAL_DATA_LOADED: {
      if (state.current !== ModalLoading) {
        return state; // user has already dismissed dialog
      }
      $('#panel-tables').popover('hide');
      if (action.payload.isLayerModal) {
        return {
          ...state,
          current: action.payload.modal,
          columns: action.payload.json.map((c) => Column.build(c)),
          existingLayer: action.payload.existingLayer,
          relevantLayers: action.payload.relevantLayers,
          templateToReplace: action.payload.additionalOptions
            ? action.payload.additionalOptions.layerToReplace
            : null,
        };
      }
      if (
        [ModalSqlEditor, ModalCsvUpload, ModalFrom].includes(
          action.payload.modal,
        )
      ) {
        return {
          ...state,
          current: action.payload.modal,
          existingLayer: action.payload.props.existing,
        };
      }
      return { ...state, current: action.payload.modal };
    }
    case USER_NOT_LOGGED_IN:
      showModal();
      return { ...state, current: UserNotLoggedInModal };
    case EMBEDDED_USER_NOT_LOGGED_IN:
      showModal();
      return { ...state, current: EmbeddedSessionExpiredModal };
    case EXCEPTION: {
      if (action.payload.layerId && state.current !== ModalAggregate) {
        return { ...state, current: ModalInvalidLayer };
      }
      return state;
    }
    case MODAL_SAVE_CLICKED:
      hideModal();
    // fallthrough!!
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset state
    case SAVE_LAYERS_CLICKED:
      showModal();
      return { ...state, current: ModalSaveLayers };
    case DEPENDANT_QUERIES_CLICKED:
      showModal();
      return { ...state, current: DependantQueriesModal };
    case CUSTOMIZE_AGGREGATE_CLICKED:
      showModal();
      return {
        ...state,
        current: ModalCustomizeAggregate,
      };
    default:
      return state;
  }
};

const Modals = combineReducers({
  whereModal,
  fromModal,
  groupByModal,
  joinModal,
  orderByModal,
  columnsModal,
  saveLayersModal,
  shareViewModal,
  selectModal,
  addColumnModal,
  collaboratorsModal,
  sqlEditorModal,
  csvUploadModal,
  hiddenColumnsModal,
  exportToSheetsModal,
  rearrangeColumnsModal,
  addAlertModal,
  addDashboardModal,
  renameColumnsModal,
  aggregateModal,
  shareAsHtmlModal,
  meta,
  modalCustomizeAggregateReducer,
});

export default Modals;
